module.exports = __webpack_public_path__ + "img/04-瞿塘峡.909567fe.jpg";